module.exports = __webpack_public_path__ + "static/img/qmwallet1-footer-help.36015e3f.png";